// TrackboardRedirect.jsx
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { callQuery, PATIENT_VISIT_BY_CSN } from '../../amplify/appsync/query';
import { PatientVisit } from '../../amplify/appsync/search-patients';
import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { NotFound } from '../nav/NotFound';

const TrackboardRedirect = (props: any) => {
    const { csn } = useParams();
    const navigate = useNavigate();

    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const fetchInternalCSN = async () => {
            try {
                callQuery({
                    operation: PATIENT_VISIT_BY_CSN,
                    csn: csn,
                })
                .then((patients: PatientVisit[]) => {
                    for (var patient of patients) {
                        setHasError(false);
                        // window.open(`/dashboard/${patient.internal_csn}`, "_blank");
                        navigate(`/dashboard/${patient.internal_csn}/${props.subpage ?? "notes"}`);
                        break;
                    }
                    setHasError(true);
                });
            } catch (error) {
                console.error('Error fetching internalCSN:', error);
                setHasError(true);
            }
        };

        if (csn) {
            fetchInternalCSN();
        }
    }, [csn, navigate]);

    if (hasError) {
        return <NotFound text='Patient Not Found' />
    }

    return (
        <Container fluid style={{paddingTop: '100px', textAlign: 'center'}}>
            <Row>
                <Col md={12}>
                    <h1 style={{color: '#AAA', fontSize: '16px'}}><FontAwesomeIcon spin icon={faSpinner} /> Loading...</h1>
                </Col>
            </Row>
        </Container>
    );
};

export default TrackboardRedirect;
